import React from 'react';
interface SectionHeaderProps {
  title: string;
  description?: string;
  centered?: boolean;
}
export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  description,
  centered = false
}) => {
  return <div className={`mb-8 md:mb-12 ${centered ? 'text-center mx-auto' : ''}`} data-id="element-148">
      <h2 className="font-poppins font-normal text-2xl md:text-3xl text-black mb-4" data-id="element-149">
        {title}
      </h2>
      {description && <p className={`font-inter text-base md:text-lg leading-relaxed text-black ${centered ? 'max-w-3xl mx-auto' : 'max-w-3xl'}`} data-id="element-150">
          {description}
        </p>}
    </div>;
};